import { useSetAtom } from 'jotai';

import { ProviderDrawerState, drawerStateAtom } from '../state';
import { ClientInformationSchedulingDrawerFooter } from './ClientInformationSchedulingDrawerFooter';

export function ClientInformationSchedulingDrawerFooterWrapper() {
  const setDrawerState = useSetAtom(drawerStateAtom);
  return (
    <ClientInformationSchedulingDrawerFooter
      onClickEditAppointment={() => setDrawerState(ProviderDrawerState.EDIT_APPOINTMENT)}
    />
  );
}
